var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCard',{staticClass:"shadow-sm m-2"},[_c('CCardBody',{staticClass:"centered"},[_c('CSpinner',{staticStyle:{"width":"5rem","height":"5rem"},attrs:{"color":"success","grow":""}}),_c('h5',{staticClass:"text-dark font-weight-normal",attrs:{"color":"#e5e5e5"}},[_vm._v("Loading...")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }